/*!
 * theme-settings.js - behaviour for Theme settings that CSS alone can't do.
 * Loaded (defer) AFTER clyro-shop.js and BEFORE clyro-alpine.js, so the money
 * formatter is in place before Alpine renders any price.
 * Reads window.themeSettings (printed by layout/theme.liquid).
 */
(function () {
  var cfg = window.themeSettings || {};
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // ── Currency format ─────────────────────────────────────────────
  // Replaces clyroShop.money with an Intl formatter: correct symbol for any
  // store currency, optional currency code, optional dropping of ".00".
  if (window.clyroShop && typeof window.clyroShop.money === 'function') {
    var fallback = window.clyroShop.money;
    window.clyroShop.money = function (cents) {
      var n = Number(cents);
      if (!isFinite(n)) n = 0;
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cfg.currency || 'GBP';
      var amount = n / 100;
      var opts = { style: 'currency', currency: cur };
      if (cfg.hideZeroDecimals && Math.round(n) % 100 === 0) {
        opts.minimumFractionDigits = 0;
        opts.maximumFractionDigits = 0;
      }
      var out;
      try {
        out = new Intl.NumberFormat(cfg.locale || document.documentElement.lang || 'en', opts).format(amount);
      } catch (e) {
        out = fallback(cents);
      }
      if (cfg.showCurrencyCode) out += ' ' + cur;
      return out;
    };
  }

  // ── Cart type: page / checkout ──────────────────────────────────
  // page:     anything that would open the drawer goes to /cart.
  // checkout: the header cart icon goes to /cart; adding to cart goes
  //           straight to /checkout (add() opens the drawer internally,
  //           which we intercept here).
  if (cfg.cartType === 'page' || cfg.cartType === 'checkout') {
    var cartUrl = cfg.cartUrl || '/cart';
    var target = cfg.cartType === 'checkout' ? (cfg.checkoutUrl || '/checkout') : cartUrl;
    if (window.clyroShop) {
      window.clyroShop.openCart = function () { window.location.href = cartUrl; };
    }
    document.addEventListener('alpine:initialized', function () {
      var A = window.Alpine;
      if (!A || !A.store || !A.effect) return;
      var cart = A.store('cart');
      if (!cart) return;
      A.effect(function () {
        if (cart.open) {
          cart.open = false;
          window.location.href = target;
        }
      });
    });
  }

  // ── Security ────────────────────────────────────────────────────
  // Skipped inside the theme editor so the merchant can still work.
  if (!designMode) {
    var isField = function (el) {
      return el && el.closest && el.closest('input, textarea, [contenteditable]');
    };
    if (cfg.noRightClick) {
      document.addEventListener('contextmenu', function (e) { if (!isField(e.target)) e.preventDefault(); });
    }
    if (cfg.noCopy) {
      document.addEventListener('copy', function (e) { if (!isField(e.target)) e.preventDefault(); });
    }
    if (cfg.noImageDrag) {
      document.addEventListener('dragstart', function (e) { if (e.target && e.target.tagName === 'IMG') e.preventDefault(); });
    }
  }
})();
